import React from 'react';
import { withSnackbar } from 'notistack';

let showNotification = () => {};

export class RsaAlert extends React.Component {
  componentDidMount() {
    showNotification = this.openSnackbar;
  }

  openSnackbar = ({ message, onCloseCallback, autoHideDuration = 3000, resumeHideDuration, variant }) => {
    const { enqueueSnackbar } = this.props;
    enqueueSnackbar(message, {
      autoHideDuration,
      resumeHideDuration,
      onClose: onCloseCallback,
      variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      }
    });
  };

  render() {
    return null;
  }
}

export function showSuccessMessage(message, config) {
  showNotification({ message, ...config, variant: 'success' });
}

export function showErrorMessage(message, config) {
  showNotification({ message, ...config, variant: 'error' });
}

export function showWarningMessage(message, config) {
  showNotification({ message, ...config, variant: 'warning' });
}

export function showInfoMessage(message, config) {
  showNotification({ message, ...config, variant: 'info' });
}

export function showNeutralNotification(message, config) {
  showNotification({ message, ...config });
}

export default withSnackbar(RsaAlert);
